/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Gender_FemaleInputs */



/**
* | output |
* | --- |
* | "female" |
*
* @param {Voice_Manager_Gender_FemaleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_gender_female = /** @type {((inputs?: Voice_Manager_Gender_FemaleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Gender_FemaleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("feminin")
	if (locale === "de") return /** @type {LocalizedString} */ ("weiblich")
	if (locale === "it") return /** @type {LocalizedString} */ ("femmina")
	if (locale === "ru") return /** @type {LocalizedString} */ ("женский")
	if (locale === "es") return /** @type {LocalizedString} */ ("femenino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("女性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("女性")
	if (locale === "hi") return /** @type {LocalizedString} */ ("महिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("fêmea")
	return /** @type {LocalizedString} */ ("female")
});